const SUPPORTED_CUSTOM_BROKERS = {
  order: [
    'ibkr',
    'degiro',
    'revolut',
    'bankinter',
    'trading212',
    'scalable',
    'tastytrade',
    'xtb',
    'andbank',
    // 'indexa',
    'ing',
    'freedom24',
    'renta4',
    'myinvestor',
    'cryptocom',
    'coinbase',
    'bitvavo',
    'kraken',
    'bitpanda',
    'bit2me',
    'ledger',
    'binance',
    'exante',
    'tradeRepublic',
  ],
  dividend: [
    'ibkr',
    'degiro',
    'revolut',
    'bankinter',
    'trading212',
    'tastytrade',
    'xtb',
    'andbank',
    'ing',
    'freedom24',
    'renta4',
    'myinvestor',
    'tradeRepublic',
  ],
  checkDuplicatesOrders: [
    'ibkr',
    'revolut',
    'bankinter',
    'andbank',
    'freedom24',
    'myinvestor',
    'trading212',
    'scalable',
    'xtb',
    'coinbase',
    'bitvavo',
    'bit2me',
    'kraken',
    'ledger',
    'tradeRepublic',
  ],
  checkDuplicatesDividends: [
    'ibkr',
    'revolut',
    'andbank',
    'freedom24',
    'myinvestor',
    'xtb',
    'degiro',
  ],
  checkCreateBuysFromExternalTransfers: ['renta4', 'myinvestor', 'andbank'],
}

const SUPPORTED_EXTERNAL_TOOLS = {
  orderExternalTool: [{ code: 'tradeStation', name: 'TradeStation' }],
}

export const getSupportedBrokersForImport = (type) => {
  return SUPPORTED_CUSTOM_BROKERS[type]
}

export const getSupportedExternalTools = (type) => {
  return SUPPORTED_EXTERNAL_TOOLS[type] || []
}

export const isBrokerSupportedForImport = ({ type, code }) => {
  if (type) return SUPPORTED_CUSTOM_BROKERS[type].indexOf(code) > -1
  return (
    SUPPORTED_CUSTOM_BROKERS.order.indexOf(code) > -1 ||
    SUPPORTED_CUSTOM_BROKERS.dividend.indexOf(code) > -1
  )
}

export const isBrokerInBetaForImport = ({ code }) => {
  if (code === 'degiro') return false
  return true
}

export const isBrokerCheckingDuplicates = ({ type, code }) => {
  if (type === 'order') return SUPPORTED_CUSTOM_BROKERS.checkDuplicatesOrders.indexOf(code) > -1
  return SUPPORTED_CUSTOM_BROKERS.checkDuplicatesDividends.indexOf(code) > -1
}

export const isBrokerCreateBuysFromExternalTransfers = ({ type, code }) => {
  if (type === 'order')
    return SUPPORTED_CUSTOM_BROKERS.checkCreateBuysFromExternalTransfers.indexOf(code) > -1
  return false
}
